// @ts-check

import { registerPlugin } from '@mailonline/dmg-ads-core/src/plugin-registry'

/**
 * @import {Context} from '@mailonline/dmg-ads-core/src/plugin-registry'
 */

import { isElementInViewport } from '@mailonline/dmg-ads-core/src/ads-utils/Viewability'

registerPlugin('position.monitor', {
  gdpr: { enabledIfDissent: true },
  ccpa: { enabledIfDissent: true },
  run
})

/**
 * @param {Context} context
 */
function run({ broker, doc, log, getConfig }) {
  log('running')
  const selectors = getConfig('plugins.position.monitor.selectors', ['#sticky_banner', '#sticky_banner_top', '#ldr_top'])
  const monitorInterval = getConfig('plugins.position.monitor.interval', 2000)
  const smartFeedSelector = getConfig('plugins.position.monitor.smartFeedSelector', '.outbrain-feed, ad-slot[pos="chumbox"]')
  const outbrainPluginIsEnabled = getConfig('plugins.enabled', []).includes('outbrain')
  if (!outbrainPluginIsEnabled) {
    log('smart_feed is disable, bailing')
    return
  }

  if (!selectors.length) {
    log('no selectors to monitor', selectors)
    return
  }

  const count = selectors.reduce((acc, selector) => {
    acc[selector] = 0
    return acc
  }, {})
  // TODO: THIS IS TEMPROARY FIX, WE NEED TO REMOVE THIS OR MAKE THIS CONFIGURABLE SOMEHOW
  /** @type {Record<string, string>} */
  const selectorMap = {
    '#sticky_banner': 'outbrain_sticky_banner', 
    '#sticky_banner_top': 'outbrain_sticky_banner_top', 
    '#ldr_top': 'outbrain_ldr_top'
  }
  setInterval(() => {
    const elements = selectors.reduce((acc, selector) => {
      const element = doc.querySelector(selector)
      if (element) {
        acc.push([element, selector])
      }
      return acc
    }, /** @type {Array<[HTMLElement, string]>} */([]))

    if (!elements.length) {
      return
    }

    const viewportTop = window.pageYOffset || document.documentElement.scrollTop
    const viewportHeight = window.innerHeight
    const viewportBottom = viewportTop + viewportHeight
    const smartFeed = document.querySelector(smartFeedSelector)
    if (!smartFeed) {
      return
    }
    const smartFeedboundingRect = smartFeed.getBoundingClientRect()
    const smartFeedTop = smartFeedboundingRect.top + window.pageYOffset
    const smartFeedBottom = smartFeedTop + smartFeedboundingRect.height
    const isSmartFeedInView = (smartFeedTop <= viewportBottom && smartFeedBottom >= viewportTop)
    if (!isSmartFeedInView) {
      return
    }

    for (const [element, selector] of elements) {
      const rect = element.getBoundingClientRect()
      if (element.isConnected && rect.height && isElementInViewport(element)) {
        log.warn(element, 'is inView')
        broker.emit('element visibile over outbrain', selectorMap[selector])
        broker.emit('send event to bidmax', {
          type: 'custom',
          payload: {
            module: 'position.monitor',
            event: 'posInViewDetected',
            selector: elementSelector(element),
            count: ++count[selector],
            height: rect.height
          }
        })
      }
    }
  }, monitorInterval)

  /**
   * @param {HTMLElement} element
   */
  function elementSelector(element) {
    return element.id
      ? `#${element.id}`
      : element.className
        ? `.${[...element.classList.values()].join('.')}`
        : element.hasAttribute('position')
          ? `position=${element.getAttribute('position')}`
          : 'unknown'
  }
}
